import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { ActionFlow } from '~shared/lib/ActionFlow'
import catalogStore from '../../Stores/CatalogStore'
import styles from './ManageMenuModal.module.scss'
import { ManageMenuListPage } from './ManageMenuListPage'
import { ManageMenuItemPage } from './ManageMenuItemPage'

interface ManageMenuModalProps {
  setManageMenuModalOpen: (isVisible: boolean) => void
  siteId: string
  departmentId: string
}

export const ManageMenuModal: React.FC<ManageMenuModalProps> = observer(
  ({ setManageMenuModalOpen, siteId, departmentId }) => {
    useEffect(() => {
      catalogStore.fetchCatalog(siteId, departmentId)
    }, [siteId, departmentId])

    return (
      <ActionFlow.Modal
        isOpen={true}
        onClose={() => setManageMenuModalOpen(false)}
        initialPath="/list"
        modalClassName={styles.manageMenuModal}
      >
        <ManageMenuListPage path="/list" />

        <ManageMenuItemPage path="/item/:itemId" siteId={siteId} />
      </ActionFlow.Modal>
    )
  }
)

export default ManageMenuModal
